import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from 'pdfmake/build/vfs_fonts';
import useDate from "../day";
import figureFormatter from "@/services/utils/figureFormatter";
import { loadImageAsBase64 } from "@/services/utils/global";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
  SulaimanLipi: {
    normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
    bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
    italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
    bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
  }
};

const printMushak61 = () => {
  const { formatDate } = useDate();
  const { commaFormat } = figureFormatter();

  const exportToPdfMushak61 = async (companyInfo, headerData, stockLedgers) => {
    const imagePath = await loadImageAsBase64('/app-assets/images/gov_seal.png');
    const doc = {
      pageSize: "A4",
      pageOrientation: "landscape",
      pageMargins: [15, 15, 15, 25],
      defaultStyle: {
        font: "SulaimanLipi",
        fontSize: 6
      },
      content: getContent(companyInfo, headerData, stockLedgers, imagePath),
      info: {
        title: 'মূসক-৬.১'
      },
      styles: styles
    };
    pdfMake.createPdf(doc).open();
  }

  const getContent = (companyInfo, headerData, stockLedgers, imagePath) => {
    return [
      getHeaderBlock(imagePath),
      { text: 'প্রতিষ্ঠানের নাম: ' + getValue(companyInfo.name), style: 'center' },
      { text: 'ব্যবসা সনাক্তকরণ সংখ্যা: ' + getValue(companyInfo.vat_no), style: 'center' },
      { text: 'ঠিকানা: ' + getValue(companyInfo.address), style: 'center' },
      { text: 'ক্রয় হিসাব পুস্তক', style: 'h2', margin: [0, 3, 0, 0] },
      { text: '(পণ্য বা সেবা প্রক্রিয়াকরণে সম্পৃক্ত এমন নিবন্ধিত বা তালিকাভুক্ত ব্যক্তির জন্য প্রযোজ্য)', style: 'small' },
      { text: '[বিধি ৪০(১) এর দফা (ক) এবং ৪১ এর দফা (ক) দ্রষ্টব্য]', style: 'small', margin: [0, 0, 0, 2] },
      { text: 'পণ্য/সেবার উপকরণ ক্রয়', style: 'small', margin: [0, 0, 0, 4] },
      {
        table: {
          headerRows: 4,
          widths: getWidths(),
          body: getTableBody(stockLedgers)
        },
        layout: {
          hLineWidth: () => 0.5,
          vLineWidth: () => 0.5,
          hLineColor: () => '#000',
          vLineColor: () => '#000',
          paddingLeft: () => 1,
          paddingRight: () => 1,
          paddingTop: () => 1,
          paddingBottom: () => 1
        }
      },
      getSpecialNote()
    ];
  }

  const getHeaderBlock = (imagePath) => {
    const seal = imagePath ? { image: imagePath, width: 50, height: 50 } : { width: 50, text: '' };
    return {
      margin: [0, 0, 0, 4],
      columns: [
        seal,
        {
          width: '*',
          stack: [
            { text: 'গণপ্রজাতন্ত্রী বাংলাদেশ সরকার', style: 'h1' },
            { text: 'জাতীয় রাজস্ব বোর্ড', style: 'h1', margin: [0, 3, 0, 0] }
          ]
        },
        {
          width: 60,
          margin: [0, 15, 0, 0],
          table: { widths: ['*'], body: [[{ text: 'মূসক-৬.১', alignment: 'center', fontSize: 8 }]] },
          layout: {
            hLineWidth: () => 1,
            vLineWidth: () => 1,
            hLineColor: () => '#000',
            vLineColor: () => '#000'
          }
        }
      ]
    };
  }

  const getWidths = () => {
    return [
      22, 28,
      20, 26,
      28, 26,
      '*', '*', 32,
      '*', 20, 26, 24, 22,
      20, 26,
      20, 26,
      20, 26,
      22
    ];
  }

  const getTableBody = (stockLedgers) => {
    return [
      getGroupHeaderRow(),
      getSubGroupHeaderRow(),
      getLeafHeaderRow(),
      getNumberRow(),
      getBlankRow(),
      ...getDataRows(stockLedgers)
    ];
  }

  const getGroupHeaderRow = () => {
    return [
      { text: 'ক্রমিক সংখ্যা', style: 'th', rowSpan: 3 },
      { text: 'তারিখ', style: 'th', rowSpan: 3 },
      { text: 'মজুদ উপকরণের প্রারম্ভিক জের', style: 'th', colSpan: 2 }, {},
      { text: 'ক্রয়কৃত উপকরণ', style: 'th', colSpan: 14 }, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {},
      { text: 'উপকরণের প্রান্তিক জের', style: 'th', colSpan: 2 }, {},
      { text: 'মন্তব্য', style: 'th', rowSpan: 3 }
    ];
  }

  const getSubGroupHeaderRow = () => {
    return [
      {}, {},
      { text: 'পরিমাণ (একক)', style: 'th', rowSpan: 2 },
      { text: 'মূল্য (সকল প্রকার কর ব্যতীত)', style: 'th', rowSpan: 2 },
      { text: 'চালানপত্র/ বিল অব এন্ট্রি নম্বর', style: 'th', rowSpan: 2 },
      { text: 'তারিখ', style: 'th', rowSpan: 2 },
      { text: 'বিক্রেতা/ সরবরাহকারী', style: 'th', colSpan: 3 }, {}, {},
      { text: 'বিবরণ', style: 'th', rowSpan: 2 },
      { text: 'পরিমাণ', style: 'th', rowSpan: 2 },
      { text: 'মূল্য (সকল প্রকার কর ব্যতীত)', style: 'th', rowSpan: 2 },
      { text: 'সম্পূরক শুল্ক (যদি থাকে)', style: 'th', rowSpan: 2 },
      { text: 'মূসক', style: 'th', rowSpan: 2 },
      { text: 'মোট উপকরণের পরিমাণ', style: 'th', colSpan: 2 }, {},
      { text: 'পণ্য প্রস্তুত/প্রক্রিয়াকরণে উপকরণের ব্যবহার', style: 'th', colSpan: 2 }, {},
      { text: 'পরিমাণ (একক)', style: 'th', rowSpan: 2 },
      { text: 'মূল্য (সকল প্রকার কর ব্যতীত)', style: 'th', rowSpan: 2 },
      {}
    ];
  }

  const getLeafHeaderRow = () => {
    return [
      {}, {},
      {}, {},
      {}, {},
      { text: 'নাম', style: 'th' },
      { text: 'ঠিকানা', style: 'th' },
      { text: 'নিবন্ধন/ তালিকাভুক্তি/ জাতীয় পরিচয়পত্র নং', style: 'th' },
      {}, {}, {}, {}, {},
      { text: 'পরিমাণ (একক)', style: 'th' },
      { text: 'মূল্য (সকল প্রকার কর ব্যতীত)', style: 'th' },
      { text: 'পরিমাণ (একক)', style: 'th' },
      { text: 'মূল্য (সকল প্রকার কর ব্যতীত)', style: 'th' },
      {}, {},
      {}
    ];
  }

  const getNumberRow = () => {
    const nums = ['(১)', '(২)', '(৩)', '(৪)', '(৫)', '(৬)', '(৭)', '(৮)', '(৯)', '(১০)', '(১১)', '(১২)', '(১৩)', '(১৪)', '(১৫)=(৩+১১)', '(১৬)=(৪+১২)', '(১৭)', '(১৮)', '(১৯)', '(২০)', '(২১)'];
    return nums.map(function (n) {
      return { text: n, style: 'th' };
    });
  }

  const getBlankRow = () => {
    return Array.from({ length: 21 }, () => ({ text: ' ', style: 'td' }));
  }

  const getDataRows = (stockLedgers) => {
    if (!stockLedgers || !stockLedgers.length) return [getBlankRow()];
    const purchases = stockLedgers.filter(function (item) {
      return item.txn_type === 'bill_journal';
    });
    const lastLedger = stockLedgers[stockLedgers.length - 1];
    if (!purchases.length) return [getClosingAdjustmentRow(getOpeningState(stockLedgers), lastLedger)];
    const rows = purchases.map((item, index) => mapRow(item, index));
    const lastShown = purchases[purchases.length - 1];
    if (getNumber(lastShown.balance_stock) === getNumber(lastLedger.balance_stock)
      && getNumber(lastShown.balance_value) === getNumber(lastLedger.balance_value)) return rows;
    rows.push(getClosingAdjustmentRow(lastShown, lastLedger));
    return rows;
  }

  const getOpeningState = (stockLedgers) => {
    const first = stockLedgers[0];
    return {
      balance_stock: getNumber(first.balance_stock) - getNumber(first.in_quantity) + getNumber(first.out_quantity),
      balance_value: getNumber(first.balance_value) - getNumber(first.in_amount) + getNumber(first.out_amount)
    };
  }

  const getClosingAdjustmentRow = (lastShown, lastLedger) => {
    return [
      { text: '', style: 'td' },
      { text: '', style: 'td' },
      { text: money(lastShown.balance_stock), style: 'tdRight' },
      { text: money(lastShown.balance_value), style: 'tdRight' },
      { text: '', style: 'td' },
      { text: '', style: 'td' },
      { text: '', style: 'tdLeft' },
      { text: '', style: 'tdLeft' },
      { text: '', style: 'tdLeft' },
      { text: 'অন্যান্য মজুদ সমন্বয়', style: 'tdLeft' },
      { text: '', style: 'tdRight' },
      { text: '', style: 'tdRight' },
      { text: '', style: 'tdRight' },
      { text: '', style: 'tdRight' },
      { text: '', style: 'tdRight' },
      { text: '', style: 'tdRight' },
      { text: '', style: 'tdRight' },
      { text: '', style: 'tdRight' },
      { text: money(lastLedger.balance_stock), style: 'tdRight' },
      { text: money(lastLedger.balance_value), style: 'tdRight' },
      { text: 'ক্রয় ব্যতীত অন্যান্য লেনদেনের প্রভাব', style: 'tdLeft' }
    ];
  }

  const mapRow = (item, index) => {
    const txnDate = getRowDate(item.date);
    const vatAmount = getNumber(item.vat_amount);
    const openingQty = getNumber(item.balance_stock) - getNumber(item.in_quantity) + getNumber(item.out_quantity);
    const openingValue = getNumber(item.balance_value) - getNumber(item.in_amount) + getNumber(item.out_amount);
    const totalQty = openingQty + getNumber(item.in_quantity);
    const totalValue = openingValue + getNumber(item.in_amount);
    const inValueNet = getNumber(item.in_amount) - vatAmount;
    return [
      { text: convertToBanglaNumber(index + 1), style: 'td' },
      { text: txnDate, style: 'td' },
      { text: money(openingQty), style: 'tdRight' },
      { text: money(openingValue), style: 'tdRight' },
      { text: getValue(item.txn_number), style: 'td' },
      { text: txnDate, style: 'td' },
      { text: getValue(item.party_name), style: 'tdLeft' },
      { text: getValue(item.party_address), style: 'tdLeft' },
      { text: getValue(item.party_bin_no), style: 'tdLeft' },
      { text: getItemLabel(item), style: 'tdLeft' },
      { text: money(item.in_quantity), style: 'tdRight' },
      { text: money(inValueNet), style: 'tdRight' },
      { text: '', style: 'tdRight' },
      { text: money(vatAmount), style: 'tdRight' },
      { text: money(totalQty), style: 'tdRight' },
      { text: money(totalValue), style: 'tdRight' },
      { text: money(item.out_quantity), style: 'tdRight' },
      { text: money(item.out_amount), style: 'tdRight' },
      { text: money(item.balance_stock), style: 'tdRight' },
      { text: money(item.balance_value), style: 'tdRight' },
      { text: '', style: 'td' }
    ];
  }

  const getItemLabel = (item) => {
    const name = getValue(item.item_name);
    if (!item.description) return name;
    return name + ' - ' + item.description;
  }

  const getRowDate = (date) => {
    if (!date) return '';
    return formatDate(new Date(date)).split(' ')[0];
  }

  const getSpecialNote = () => {
    return {
      stack: [
        { text: 'বিশেষ দ্রষ্টব্যঃ', fontSize: 8 },
        { text: '১। অর্থনৈতিক কার্যক্রম সংশ্লিষ্ট সকল প্রকার ক্রয়ের তথ্য এই ফরমে অন্তর্ভুক্ত করিতে হইবে।', fontSize: 8 },
        { text: '২। যে ক্ষেত্রে অনিবন্ধিত ব্যক্তির নিকট হইতে পণ্য ক্রয় করা হইবে সেই ক্ষেত্রে উক্ত ব্যক্তির পূর্ণাঙ্গ নাম, ঠিকানা ও জাতীয় পরিচয়পত্র নম্বর যথাযথভাবে সংশ্লিষ্ট কলাম [(৭), (৮) ও (৯)] এ আবশ্যিকভাবে উল্লেখ করিতে হইবে।', fontSize: 8 },
        { text: '৩। উপকরণ ক্রয়ের স্বপক্ষে প্রামাণিক দলিল হিসাবে বিল অব এন্ট্রি বা চালানপত্রের কপি সংরক্ষণ করিতে হইবে।', fontSize: 8 }
      ],
      margin: [0, 6, 0, 0]
    };
  }

  const getValue = (value) => {
    if (!value) return '';
    return value;
  }

  const getNumber = (value) => {
    if (!value) return 0;
    return parseFloat(value);
  }

  const money = (value) => {
    if (!value) return 0;
    return commaFormat(value);
  }

  const convertToBanglaNumber = (number) => {
    const banglaDigits = ['০', '১', '২', '৩', '৪', '৫', '৬', '৭', '৮', '৯'];
    return number.toString().split('').map(d => banglaDigits[d] || d).join('');
  }

  const styles = {
    h1: { fontSize: 11, alignment: 'center' },
    h2: { fontSize: 9, alignment: 'center' },
    center: { fontSize: 8, alignment: 'center' },
    small: { fontSize: 8, alignment: 'center' },
    th: { fontSize: 6, alignment: 'center', lineHeight: 1.1 },
    td: { fontSize: 6, alignment: 'center' },
    tdRight: { fontSize: 6, alignment: 'right' },
    tdLeft: { fontSize: 6, alignment: 'left' }
  };

  return {
    exportToPdfMushak61
  }
}

export default printMushak61;
